//http://localhost:3000/reset-password/c62cc2c2165380d8c23797e7bb2b0b9d

import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import AuthPageLayout from "../../../../components/AuthPageLayout";
import Transition from "../../../../../../components/Transition";
import ButtonLoader from "../../../../../../components/ButtonLoader";
import { ResetPasswordCALL } from "../../../../network/api/ResetPassword";
import { AnimatePresence } from "framer-motion";


export default function ResetPassword() {
    const { token } = useParams();

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [success, setSuccess] = useState(false);


    const [formData, setFormData] = useState({
        password: "",
        password2: "",
        token: token
    });

    const handleChange = (e) => {
        setErrorMessage("");

        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleSubmit = async (e) => {
        setErrorMessage("");
        setIsLoading(true);
        e.preventDefault();

        const newErrors = {};
        if (!formData.password.trim()) newErrors.password = "Passowrd is required";
        if (!formData.password2.trim()) newErrors.password2 = "Confirm Passowrd is required";

        if (formData.password2.trim() !== formData.password.trim()) {
            setErrorMessage("Password do not match");
            setIsLoading(false);
            return;
        }


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsLoading(false);
            return;
        }


        //submit data here
        const response = await ResetPasswordCALL(formData);

        if (response.status === "success") {
            setIsLoading(false);
            setSuccess(true);
            setErrorMessage(response.message);

        } else {
            setIsLoading(false);
            setErrorMessage(response.message);
        }

    }


    return (
        <AuthPageLayout>
            <h4 className="text-center mb-4">Reset account password</h4>
            {!isLoading && errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={errorMessage} >
                        <div className={`alert alert-${success ? "success" : "danger"} alert-dismissible alert-alt solid fade show`}>
                            <strong>{success ? "Success" : "Error!"}</strong> {errorMessage}
                        </div>
                    </Transition>
                </AnimatePresence>
            ) : null}

            <form onSubmit={handleSubmit}>

                <div className="mb-3 position-relative">
                    <label className="mb-1"><strong>Password</strong></label>
                    <input
                        type="password"
                        id="dz-password"
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        placeholder="********"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        disabled={success}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    <span className="show-pass eye">
                        <i className="fa fa-eye-slash"></i>
                        <i className="fa fa-eye"></i>
                    </span>
                </div>

                <div className="mb-3 position-relative">
                    <label className="mb-1"><strong>Confirm Password</strong></label>
                    <input
                        type="password"
                        id="dz-password2"
                        className={`form-control ${errors.password2 ? "is-invalid" : ""}`}
                        placeholder="********"
                        name="password2"
                        value={formData.password2}
                        onChange={handleChange}
                        disabled={success}
                    />
                    {errors.password2 && <div className="invalid-feedback">{errors.password2}</div>}
                    <span className="show-pass eye">
                        <i className="fa fa-eye-slash"></i>
                        <i className="fa fa-eye"></i>
                    </span>
                </div>


                <div className="text-center mt-4">
                    {!success ?
                        <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                            {isLoading ? <ButtonLoader /> : "Update Password"}
                        </button>
                        : <Link to="/login" className="btn btn-primary btn-block">Sign in</Link>
                    }
                </div>

            </form>

        </AuthPageLayout>
    );
}